"use client";

export function SceneAtmosphere({
  x = "50%",
  y = "50%",
  intensity = 0.16,
  size = 60,
  className = "",
}: {
  x?: string;
  y?: string;
  intensity?: number;
  size?: number;
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        background: `radial-gradient(${size}% ${size}% at ${x} ${y}, color-mix(in oklch, var(--color-primary) ${
          intensity * 100
        }%, transparent) 0%, transparent 70%)`,
      }}
    />
  );
}
